// FILE: src/components/search/SearchInput.jsx
import React, { forwardRef } from 'react';

/**
 * SearchInput: accessible input for combobox usage.
 * Props:
 *  - value, onChange
 *  - onKeyDown (keyboard handlers forwarded to parent)
 *  - controlsId (id of the result list, e.g. "search-results-list")
 *  - expanded (boolean) whether popover/list is visible (for aria-expanded)
 */
const SearchInput = forwardRef(({ value, onChange, onKeyDown, controlsId = 'search-results-list', expanded = false }, ref) => {
  return (
    <div className="w-full">
      <label htmlFor="orrith-search" className="sr-only">
        Search Orrith
      </label>

      <input
        id="orrith-search"
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Search Orrith — members, products, market signals..."
        className="w-full px-4 py-3 rounded-lg border border-gray-200 dark:border-neutral-800 bg-white dark:bg-neutral-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
        aria-label="Search Orrith"
        aria-autocomplete="list"
        role="combobox"
        aria-controls={controlsId}
        aria-expanded={expanded}
        autoComplete="off"
      />
    </div>
  );
});

export default SearchInput;

